import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    conditions: Array,
    trigger: String
  }

  connect() {
    const form = this.element.closest('form')
    if (!form) return

    this.triggerField = form.querySelector(`[name="resource[${this.triggerValue}]"]`)
    if (!this.triggerField) return

    this.handleChange = this.updateOptions.bind(this)
    this.triggerField.addEventListener('change', this.handleChange)

    // Defer initial update so the child select controller (Tom Select) can initialize first
    requestAnimationFrame(() => this.updateOptions())
  }

  disconnect() {
    if (this.triggerField && this.handleChange) {
      this.triggerField.removeEventListener('change', this.handleChange)
    }
  }

  updateOptions() {
    const triggerValue = this.triggerField.tomselect
      ? this.triggerField.tomselect.getValue()
      : this.triggerField.value

    const condition = this.conditionsValue.find(c => c.value === triggerValue)
    const choices = condition?.choices || []

    const selectEl = this.element.querySelector('select')
    if (!selectEl || !selectEl.tomselect) return

    const ts = selectEl.tomselect
    const currentValue = ts.getValue()

    ts.clear(true)
    ts.clearOptions()
    choices.forEach(choice => {
      ts.addOption({ value: choice, text: choice })
    })

    if (currentValue && choices.includes(currentValue)) {
      ts.setValue(currentValue, true)
    }

    ts.refreshOptions(false)
  }
}
